import React from 'react';
import { ComposableMap, Geographies, Geography, Marker } from 'react-simple-maps';

const GEO_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json';

export const WorldMap = ({ points = [] }) => {
  const max = Math.max(1, ...points.map((p) => p.visitors || 0));

  return (
    <div data-testid="visitor-world-map" style={{ width: '100%' }}>
      <ComposableMap projectionConfig={{ scale: 145 }} height={400} style={{ width: '100%', height: 'auto' }}>
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#E5E7EB"
                stroke="#ffffff"
                strokeWidth={0.5}
                style={{
                  default: { outline: 'none' },
                  hover: { fill: '#D1D5DB', outline: 'none' },
                  pressed: { outline: 'none' },
                }}
              />
            ))
          }
        </Geographies>
        {points.map((p, i) => {
          const r = 4 + (Math.sqrt((p.visitors || 0) / max)) * 16;
          return (
            <Marker key={i} coordinates={[p.lon, p.lat]}>
              <circle r={r} fill="#00D4B4" fillOpacity={0.45} stroke="#00D4B4" strokeWidth={1.2} />
            </Marker>
          );
        })}
      </ComposableMap>
    </div>
  );
};

export default WorldMap;
